import {
    getConfig,
    getExperimentVariantFromConfig,
} from '../../../../../config';
import { UNLEASH_FEATURE_NAMES } from '../../../../../../shared/unleash/feature-names';
import { MarketContentDesignExperimentVariants } from '../../../../../../shared/types/contentMarketing';
import * as React from 'react';
import HorizontalBlock from '../../../blocks/horizontal-block';
import VerticalBlock from '../../../blocks/vertical-block';
import SponsorHeader from '../../../components/sponsor-header';
import FabricAnchorCard from '../../../components/fabric-anchor-card';

const RealEstateSectionSingle = ({ contentMarketing }) => {
    const { deviceType } = getConfig();

    const experimentOverrideImageSide = getExperimentVariantFromConfig(
        UNLEASH_FEATURE_NAMES.contentMarketingLeftSideImage,
    ) as MarketContentDesignExperimentVariants;

    const hasLeftImage =
        experimentOverrideImageSide === 'challengerImageLeftSide';

    if (deviceType === 'mobile') {
        return (
            <>
                <SponsorHeader contentMarketing={contentMarketing} />
                <FabricAnchorCard href={contentMarketing.href}>
                    <VerticalBlock
                        isMultipleAds={false}
                        noPadding={false}
                        contentMarketing={contentMarketing}
                    />
                </FabricAnchorCard>
            </>
        );
    }
    return (
        <FabricAnchorCard href={contentMarketing.href}>
            <HorizontalBlock
                noPadding={false}
                contentMarketing={{
                    ...contentMarketing,
                    imagePosition: hasLeftImage ? 'left' : 'right',
                }}
            />
        </FabricAnchorCard>
    );
};

export default RealEstateSectionSingle;
